import { t } from 'localization'
import { HomepageQA } from 'shared/dataAttributes'
import { useWindowSize } from 'shared/hooks/useWindowSize'
import { CMSVideoAsset } from 'shared/types/CMSVideoAsset'
import styled from 'styled-components'

type VideoHeroProps = {
  videos: CMSVideoAsset[]
}

const TP = 'homepage.VideoHero'

const VideoHero = ({ videos }: VideoHeroProps) => {
  const [defaultVideo, mobileVideo] = videos
  const { url: urlDefault, poster: posterDefault } = defaultVideo
  const urlMobile = mobileVideo?.url
  const posterMobile = mobileVideo?.poster
  const { isMobile } = useWindowSize()

  const url = isMobile && urlMobile ? urlMobile : urlDefault
  const poster = isMobile && posterMobile ? posterMobile : posterDefault

  return (
    <VideoHeroWrapper $isMobile={isMobile}>
      <StyledVideo
        autoPlay
        data-qa={HomepageQA.VideoHero}
        disablePictureInPicture
        loop
        muted
        playsInline
        poster={poster?.largeUrl}
        preload="auto"
        src={`${url}#t=0.5`}
      >
        <source src={url} type="video/mp4" />
        <source src={url} type="video/ogg" />
        {t(`${TP}.heroVideoNotSupported`, 'Your browser does not support the video.')}
      </StyledVideo>
    </VideoHeroWrapper>
  )
}

const StyledVideo = styled.video`
  display: block;
  height: 100vh !important;
  left: 0;
  object-fit: cover !important;
  position: absolute;
  top: 0;
  width: 100vw !important;
`
const VideoHeroWrapper = styled.div<{ $isMobile?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

export default VideoHero
